export function setLoading (state, module) {
  let isLoading = state.loading.includes(module)
  if(isLoading === true) {
    state.loading = state.loading.filter(el => el !== module)
  } else {
    state.loading.push(module)
  }
}

export function setToday (state, today = '') {
  state.today = today
}

export function setLang (state, lang = 'ro') {
  state.lang = lang
}
